if (!customElements.get('contact-form')) {
    class ContactForm extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.form = this.querySelector('form');
            if (!this.form) return;

            this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }

        handleSubmit(event) {
            event.preventDefault();

            const customFieldData = this.querySelectorAll('[data-custom-field]');
            const messageField = this.querySelector('textarea[name="contact[body]"]');

            if (!messageField) return;

            let customFieldValues = {};
            customFieldData.forEach(item => {
                const label = item.dataset.label || item.name || 'field';
                customFieldValues[label] = item.value;
            });

            if (Object.keys(customFieldValues).length === 0) {
                this.form.submit();
                return;
            }

            let customFieldMessage = '\n\n---\n';
            for (const [key, value] of Object.entries(customFieldValues)) {
                customFieldMessage += `${key}: ${value}\n`;
            }

            messageField.value = messageField.value + customFieldMessage;

            this.form.submit();
        }
    }

    customElements.define('contact-form', ContactForm);
}